"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV_NETWORKS_MAP = exports.EnvironmentTypes = exports.OperationTypes = void 0;
exports.getExplorerUrl = getExplorerUrl;
const networks_1 = require("./networks");
exports.OperationTypes = {
    TX_HASH: 'txHash',
    WALLET_ADDRESS: 'address',
};
exports.EnvironmentTypes = {
    DEV: 'dev',
    RC: 'rc',
    SANDBOX: 'sandbox',
    PROD: 'prod',
    APAC: 'apac',
};
function genericExplorerUrlBuilder(explorerUrlTemplateString, operation, value) {
    if (operation === exports.OperationTypes.TX_HASH) {
        return explorerUrlTemplateString
            .replace('{operation}', 'tx')
            .replace('{value}', value);
    }
    else {
        return explorerUrlTemplateString
            .replace('{operation}', 'address')
            .replace('{value}', value);
    }
}
exports.ENV_NETWORKS_MAP = {
    [exports.EnvironmentTypes.DEV]: networks_1.NETWORKS_DEV,
    [exports.EnvironmentTypes.RC]: networks_1.NETWORKS_RC,
    [exports.EnvironmentTypes.SANDBOX]: networks_1.NETWORKS_SANDBOX,
    [exports.EnvironmentTypes.PROD]: networks_1.NETWORKS_PROD,
    [exports.EnvironmentTypes.APAC]: networks_1.NETWORKS_APAC,
};
function getExplorerUrl({ blockchainNetwork, operation, value, environment, }) {
    const networks = exports.ENV_NETWORKS_MAP[environment];
    const network = networks.find(network => network.id === blockchainNetwork);
    if (!network || !network.explorerUrlTemplateString) {
        return null;
    }
    if (network.explorerUrlBuilder) {
        return network.explorerUrlBuilder(network.explorerUrlTemplateString, operation, value);
    }
    else {
        return genericExplorerUrlBuilder(network.explorerUrlTemplateString, operation, value);
    }
}
//# sourceMappingURL=network-utils.js.map